import GooglePublisherTag from 'components/shared/GooglePublisherTag/GooglePublisherTag';
import SharedBannerAd from 'components/shared/BannerAd/BannerAd';

export default class BannerAd {
  static setup() {
    if(window.kmklabs === undefined) return
    var gpt = window.kmklabs.gpt;

    if(gpt.leaderboard_ad_unit && gpt.leaderboard_ad_size) {
      BannerAd.adjustLeaderboardContainer();
      BannerAd.setLeaderboard(gpt);
    }

    if(gpt.pause_ad_unit && gpt.pause_ad_size)
      GooglePublisherTag.setPauseAd(gpt.pause_ad_unit, gpt.pause_ad_size);

    if(gpt.overlay_ad_unit && gpt.overlay_ad_size)
      GooglePublisherTag.setOverlayAd(gpt.overlay_ad_unit, gpt.overlay_ad_size);

    if(gpt.middle_banner_ad_unit && gpt.middle_banner_ad_size)
      SharedBannerAd.setBannerAd(
        "middle_banner_container",
        "middle_banner",
        gpt.middle_banner_ad_unit,
        gpt.middle_banner_ad_size,
        GooglePublisherTag.displayMiddleBannerAd,
      );
  };

  static setLeaderboard(gpt) {
    let interval = window.__adsConfig && window.__adsConfig.leaderboard_refresh_interval || 0;

    SharedBannerAd.setBannerAd(
      "leaderboard_container",
      "leaderboard",
      gpt.leaderboard_ad_unit,
      gpt.leaderboard_ad_size,
      GooglePublisherTag.displayLeaderboardAd,
      () => {
        GooglePublisherTag.refreshAdSlot(gpt.leaderboard, 'leaderboard', true, interval);
      }
    );
  };

  static adjustLeaderboardContainer() {
    const container = document.getElementById('leaderboard_container')
    if(container) {
      container.style.height = '90px'
      container.style.margin = '18px auto 0px auto'
    }
  }
};  